import { AlertCircle, CheckCircle, InfoCircle } from '@untitledui/icons'

export const STATE_ICONS = {
  info: InfoCircle,
  success: CheckCircle,
  warning: AlertCircle,
  error: AlertCircle,
}